// extracted by mini-css-extract-plugin
export default {"container":"info_container__Q3i78","heading":"info_heading__kNd8X","text":"info_text__u0v33","imgContainer":"info_imgContainer__LYKV0"};